import { render, staticRenderFns } from "./GalleryAddEditModal.vue?vue&type=template&id=0bae0624&"
import script from "./GalleryAddEditModal.vue?vue&type=script&lang=js&"
export * from "./GalleryAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports